import type { Recipient, RecipientStatus } from "@kontaktfix/shared";
import { StatusDot, Tooltip } from "@kontaktfix/ui";
import { useTranslation } from "react-i18next";

const TONES: Record<RecipientStatus, "success" | "warning" | "danger" | "neutral" | "accent"> = {
  ok: "success",
  pending: "neutral",
  syncing: "accent",
  removing: "accent",
  error: "danger",
  unreachable: "warning",
};

export function RecipientStatusLabel({
  recipient,
}: {
  recipient: Pick<Recipient, "status" | "reason" | "reasonDetail">;
}) {
  const { t } = useTranslation();
  const label = (
    <span className="inline-flex items-center gap-2 text-[13px] whitespace-nowrap">
      <StatusDot
        tone={TONES[recipient.status]}
        pulse={recipient.status === "syncing" || recipient.status === "pending"}
      />
      {t(`status.${recipient.status}`)}
    </span>
  );
  if (!recipient.reason) return label;
  return (
    <Tooltip
      content={
        recipient.reasonDetail
          ? `${t(`reasons.${recipient.reason}`)}: ${recipient.reasonDetail}`
          : t(`reasons.${recipient.reason}`)
      }
    >
      <span className="inline-flex flex-col">
        {label}
        <span className="pl-4 text-[11.5px] text-fg-muted">{t(`reasons.${recipient.reason}`)}</span>
      </span>
    </Tooltip>
  );
}
